import React from 'react';
import { useState } from 'react';

const ActivationContent = () => {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    const email = 'support@disgenet.com';
    navigator.clipboard.writeText(email);
  };

  return (
    <section>
      <style>{`
        .copy-info {
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          text-decoration: underline;
          color: rgb(190,0,128);
        }
        .a-search{
          color: rgb(190,0,128);
        }
      `}</style>
      <div className="container">
        <div data-wow-delay="0.3s" className="p-4 activated-page">
          <h1 className="text-6xl font-bold mb-12">Free Trial Activated</h1>
          <br />
          <h5>
            You now have access to the <span className="text-pink">DISGENET Advanced plan</span>.
          </h5>
          <p className="warning-text-activated-page">Remember that your trial period will end in 7 days.</p>
          <br />
          <h5 className="mt-2 w-1/3 mx-auto">
            Start searching for the most recent and relevant data on disease genomics by{' '}
            <a
              className="bg-pink text-white text-sm px-2 py-1 rounded-md hover:bg-blue transition-colors duration-300"
              href="/"
            >
              clicking here.
            </a>
          </h5>
          <br />
          <p>
            For more information, contact us{' '}
            <a href="/Support" className="copy-info" title="copy" onClick={copyEmail}>
              here
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  );
};

export default ActivationContent;
